var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',{attrs:{"colspan":_vm.numberOfColumns}},[_vm._t("default",function(){return [_c('div',{staticClass:"DataTable-NoContentPlaceholder",attrs:{"data-testid":"DataTable-NoContentPlaceholder"}})]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }